import React, { useEffect, useRef } from 'react';
import { Button, Alert, Flex, Card } from 'antd';
import BotaoDownload from 'components/Botoes/BotaoDownload/BotaoDownload';
import { useRoteiro } from 'context/RoteiroContext';

function OperacaoInvalida({reiniciarProcesso, baixarArquivoErroUltimoLog}) {
    const {setReferenciaObjetosVisuais} = useRoteiro();
    const refBotaoBaixarErros = useRef(null);
    const refs = [
        { id: 'refCriacaoMultiplosUsuariosBotaoBaixarErros', ref: refBotaoBaixarErros }
    ];

    useEffect(()=>{
            inicializarPagina();
        }, []);
    
    const inicializarPagina = async () => {
        setReferenciaObjetosVisuais(refs);
    }

    return (
        <Card title="Resultado da validação do arquivo">
            <Alert
                message={<strong>Último arquivo inválido</strong>}
                description={<span>Clique em <strong>"Baixar erros"</strong> para verificar as inconsistências do arquivo anterior e envie uma nova solicitação com as correções.</span>}
                type="error"
                showIcon
                style={{ marginBottom: 24 }}
            />

            <Flex gap="small">
                <Button type="primary" onClick={reiniciarProcesso}>
                    Nova solicitação
                </Button>

                <BotaoDownload
                    apiCallback={() => baixarArquivoErroUltimoLog()}
                    linkName="arquivoErroUltimoLog"
                    message="Baixar erros"
                    refReact={refBotaoBaixarErros}
                />
            </Flex>
        </Card>
    );
}

export default OperacaoInvalida;